import { format, parse } from 'date-fns';
import de from 'date-fns/locale/de';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';

// Same function from Shop(Redbubble/delivery-dates) and Monolith
export const calendarDateRange = (low: string, high: string) => {
  const range = `${low} - ${high}`;
  return range.replace(/(\d+)\s(.+)\s-\s(\d+).*\2/, '$1 - $3 $2');
};

const dateLocaleMap = { es, fr, de };

const dateFormatMap = {
  en: 'd MMMM',
  es: "d 'de' MMMM",
  de: 'd. MMMM',
};

const dateFormatter = (date: string, locale: string, dateFormat: string) => {
  if (!date) return '';

  return format(parse(date, 'yyyy-MM-dd', new Date()), dateFormat, {
    locale: dateLocaleMap[locale],
  });
};

// convert date from "2022-08-26" to:
// en, fr: "<date no ordinal> <full month>"
// es: <date no ordinal> de <full month>
// de: <date no ordinal>. <full month>
export const formatDate = (date: string, locale: string) => {
  const dateFormat = dateFormatMap[locale] || dateFormatMap.en;

  return dateFormatter(date, locale, dateFormat);
};

// convert date from "2022-08-26" to "<full month> <date no ordinal>" in all locales
export const formatMonthFirstDate = (date: string, locale: string) => {
  return dateFormatter(date, locale, 'MMMM d');
};
